module.exports = __webpack_public_path__ + "img/main.md.857794d2.webp";